import { createContext } from 'react';

import { IDashboardContext } from './interfaces';

const DashboardContext = createContext<IDashboardContext | null>(null);

export default DashboardContext;
